import React from 'react';

const WIDGET_OPTIONS = [
  {
    type: 'series_popularity',
    title: 'Series Popularity',
    description: 'View popularity stats for all racing series',
    icon: 'chart-bar',
  },
  {
    type: 'irating_distribution',
    title: 'iRating Distribution',
    description: 'See how iRatings are distributed across categories',
    icon: 'chart-line',
  },
  {
    type: 'lap_times_boxplot',
    title: 'Lap Times',
    description: 'Compare lap times across different cars in a series',
    icon: 'stopwatch',
  },
  {
    type: 'career_stats',
    title: 'Career Stats',
    description: 'Track career statistics for any driver',
    icon: 'trophy',
  },
  {
    type: 'series_safety',
    title: 'Series Safety',
    description: 'View incident statistics per racing series',
    icon: 'shield',
  },
];

function WidgetSelector({ onSelect, onClose }) {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="widget-selector-overlay" onClick={handleOverlayClick}>
      <div className="widget-selector-modal">
        <div className="widget-selector-header">
          <h2>Add Widget</h2>
          <button className="widget-selector-close" onClick={onClose}>
            &times;
          </button>
        </div>

        <div className="widget-selector-grid">
          {WIDGET_OPTIONS.map((option) => (
            <div
              key={option.type}
              className="widget-option"
              onClick={() => onSelect(option.type)}
            >
              <div className="widget-option-icon">
                {getIcon(option.icon)}
              </div>
              <div className="widget-option-content">
                <h3>{option.title}</h3>
                <p>{option.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function getIcon(iconName) {
  const icons = {
    'chart-bar': (
      <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
        <path d="M3 12h4v9H3v-9zm7-5h4v14h-4V7zm7-4h4v18h-4V3z" />
      </svg>
    ),
    'chart-line': (
      <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
        <path d="M3 17l6-6 4 4 8-8v3h2V3h-7v2h3l-6 6-4-4-8 8v3z" />
      </svg>
    ),
    'stopwatch': (
      <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
        <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h2v5l4.2 2.6-.8 1.6z" />
      </svg>
    ),
    'trophy': (
      <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
        <path d="M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94A5.01 5.01 0 0011 15.9V19H7v2h10v-2h-4v-3.1a5.01 5.01 0 003.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z" />
      </svg>
    ),
    'shield': (
      <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
        <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" />
      </svg>
    ),
  };

  return icons[iconName] || null;
}

export default WidgetSelector;
